import React from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Pawprint from '../assets/Pawprint';

export type StepMarkerStatus = 'inactive' | 'active' | 'completed';

export interface StepMarkerProps {
  status?: StepMarkerStatus;
}

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 33.5,
    width: 33.5,

    [theme.breakpoints.up('md')]: {
      height: 37,
      width: 37,
    },
  },
  inactiveMarker: {
    backgroundColor: '#ffb781',
    borderRadius: '50%',
    width: 16.75,
    height: 16.75,

    [theme.breakpoints.up('md')]: {
      width: 18.5,
      height: 18.5,
    },
  },
  activeMarker: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: '#f7f7fa',

    [theme.breakpoints.up('md')]: {
      border: '2px solid #ffffff',
      backgroundColor: theme.palette.primary.main,
    },
  },
  completedMarker: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,

    [theme.breakpoints.up('md')]: {
      borderColor: '#fff',
      backgroundColor: '#fff',
    },
  },
}));

const StepMarker = (props: StepMarkerProps) => {
  const { status = 'inactive' } = props;
  const classes = useStyles(props);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (status === 'active') {
    return (
      <div className={clsx(classes.root, classes.activeMarker)}>
        <Pawprint fill={isDesktop ? '#fff' : theme.palette.primary.main} />
      </div>
    );
  }

  if (status === 'completed') {
    return (
      <div className={clsx(classes.root, classes.completedMarker)}>
        <Pawprint fill={isDesktop ? theme.palette.primary.main : '#fff'} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.inactiveMarker} />
    </div>
  );
};

export default StepMarker;
